import { useEffect, useState } from "react";
import { _single, _Test } from "../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../core/services/dataBean/useDataBean";
import { BasicPage } from "../../theme/Component/BasicPage";
import { PrintJson } from "../../theme/Component/PrintJson";
import { YearSelector } from "../../../core/shared/inputs/YearSelector";
import { SelectMonths } from "../../contract/select/SelectMonths";
import { BasicButton } from "../../theme/Component/BasicButton";
import { toast } from "react-toastify";
import { SpanRender } from "../../theme/Component/SpanRender";
import { ProofResponseGraph } from "./ProofResponseGraph";
import ScrollableListWithExport from "./ScrollableListWithExport";
import useModal, { MODAL_md, MODAL_XL } from "../../theme/Component/hooks/useModal";
import { Modal } from "../../theme/Component/Modal";
import { BasicTable, MASK_NUMBER } from "../../theme/Component/BasicTable";


export const ProofResult = () => {

    const _test = useDataBean(_Test);
    const { bean, setBean, lista, setLista } = _test;

    const [idTest, setIDTest] = useState<number>(0);
    const [year, setYear] = useState<number>(_single.getCurrenYear());
    const [month, setMonth] = useState<number>(_single.getCurrentMonth());
    const [test, setTest] = useState<any>([]);
    const [questions, setQuestions] = useState<any>([]);
    const [key, setKey] = useState<number>(_single.getRandomInt());
    const modalDetalle = useModal("Detalle", MODAL_md);
    const [detalleList, setDetalleList] = useState<any>([]);

    useEffect(() => {
        _test.getLista({ State: 1 }, null);
    }, [])
    useEffect(() => {
        if (lista.length > 0)
            setIDTest(lista[0].DataBeanProperties.IDTest);
    }, [lista])

    const getResults = () => {
        if (idTest > 0) {
            _test.instance.getTestResult(idTest, year, month).then(
                (resp: any) => {
                    setTest(resp);
                    if (resp.Questions)
                        setQuestions(resp.Questions);
                    // setKey(_single.getRandomInt());
                })
        } else {
            toast.warning("Seleccione una encuesta");
        }
    }

    const getListaAbierta = (lista: any) => {
        let temp = [];

        lista.forEach(element => {
            temp.push(element.DataBeanProperties.ValueOption);
        });
        return temp;
    }
    const getDetallePregunta = (test, question) => {
        let filter = {
            IDTest: test,
            IDTestQuestion: question,
            Year: year,
            Month: month
        }
        
        _test.instance.getProofResponsesByQuesitonAndTest(1, 1000, filter).then(
            (resp: any) => {
                setDetalleList(resp.List);
                modalDetalle.open();
                }
            )            
        
    }

    const head = [

        { title: 'Identificación', property: 'Nit', visible: true },
        { title: 'Nombre', property: 'EntityName', visible: true },
        { title: 'Respuesta', property: 'ResponseValue', visible: true },
        { title: 'Justificación', property: 'JustificaAnswer', visible: true },
    ]


    return (
        <BasicPage titulo="Resultados">
            <div className="row">
                <div className="col-md-3">
                    <label>Encuesta</label>
                    <select name="ent" id="encu" className="form-select" value={idTest} onChange={(e) => { setIDTest(parseInt(e.target.value)) }}>
                        {lista.map((item, index) => {
                            return (
                                <option key={index} value={item.DataBeanProperties.IDTest}>{item.DataBeanProperties.Name}</option>
                            )
                        })}
                    </select>
                </div>
                <div className="col-md-3">
                    <YearSelector value={year} onChange={(e) => { setYear(e) }} tittle="Año" />
                </div>
                <div className="col-md-3">
                    <SelectMonths idSelector={month} onChange={(e) => { setMonth(e) }} />
                </div>
                <div className="col-md-3">
                    <BasicButton useMargin icon="" eventClick={getResults}>Buscar</BasicButton>
                </div>
                <div className="col-md-12">
                    <hr />
                    <div className="row mt-4">
                        {questions.filter((item) => item.DataBeanProperties.QuestionType != 4).map((item, index) => {
                            return (
                                <>

                                    <div key={index} className="col-md-6">
                                        <fieldset>

                                        <div className="card-body">
                                            <p> 
                                                <SpanRender value={item.DataBeanProperties.Question} />
                                                {/* <br /> */}
                                                <span className="text-primary cursor" onClick={() => { getDetallePregunta(item.DataBeanProperties.IDTest, item.DataBeanProperties.IDTestQuestion) }} >Ver Detalle</span>
                                                {/* <BasicButton icon="" eventClick={() => { getDetallePregunta(item.DataBeanProperties.IDTest, item.DataBeanProperties.IDTestQuestion) }}>Ver Detalle</BasicButton> */}
                                            </p>
                                            {/* <PrintJson json={item.DataBeanProperties}/> */}
                                            <ProofResponseGraph lista={item.DataBeanProperties.Responses} title={item.DataBeanProperties.Question} />
                                        </div>
                                        </fieldset>
                                    </div>

                                </>
                            )
                        })}
                    </div>
                </div>
                <div className="col-md-12">
                    <h5>Preguntas Abiertas</h5>
                    {questions.filter((item) => item.DataBeanProperties.QuestionType == 4).map((item, index) => {
                        return (
                            // <PrintJson json={item.DataBeanProperties.Responses}/>
                            <ScrollableListWithExport title={item.DataBeanProperties.Question} items={getListaAbierta(item.DataBeanProperties.Responses)} />
                        )
                    })}
                </div>
                <div className="col-md-12">
                    <Modal modal={modalDetalle.modal} updateModal={modalDetalle.setModal}>
                        <div className="row">
                            <div className="col-md-12">
                                <BasicTable body={detalleList} head={head} rowSet={(e) => { }}></BasicTable>
                                {/* <PrintJson json={detalleList} /> */}
                            </div>
                        </div>
                    </Modal>
                </div>
                <div className="col-md-12">
                    {/* <PrintJson json={test} /> */}
                </div>

            </div>
        </BasicPage>
    )
}